// The homepage. Includes everything that shows on the home page except the
// navbar, which is its own component named Navbar.js

// IMPORTS FROM MUI AND REACT-ROUTER-DOM
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

// PICTURE IMPORTS (pictures are kept in the src folder one folder up from this component)
import tent from "../tent.jpg";
import wintertrailer from "../wintertrailer_confirmedcopyrightfreefrompexels.jpg";
import rulesPic from "../rules_picture.jpg"; // 1
import personwithmap from "../personwithmap_confirmedcopyrightfreefrompexels.jpg";
import kayak from "../kayak_confirmedcopyrightfreefrompexels.jpg";
// import kayak from '../2.jpg'

// THE ACTUAL PAGE
export const Home = () => {
  return (
    <div className="homepage-cards-container">
      {/* BOOKING CARD */}
      {/* This div is necessary around the cards... not sure why but the margins and paddings do weird stuff if i take it away*/}
      <div>
        <Card className="card" sx={{ ":hover": { boxShadow: 20 } }}>
          <img src={tent} height="330em" className="homepage-cards-img" />
          <div className="cardContent">
            <Typography variant="h5" className="homepage-cardtitle">
              Book
            </Typography>
            <Typography className="card-text">
              Before booking please be aware that we have a strictly enforced
              11PM quiet time to ensure everyone can get a good night's sleep
              while they are here! We are the opposite of a party campground.
              {/* To make sure everyone else's camping experience is the best it can be, we don't accept large groups.  */}
              {/* Before booking please be aware that we are a quiet family-friendly campground! 
                        We have an 11PM quiet time to make sure everyone can get a good night's sleep while they're here. */}
              {/* We are not a 
                        drink-till-midnight-and-play-loud-music-and-annoy-the-sites-around-you type of campground. */}
            </Typography>
            <CardActions sx={{ paddingLeft: "0" }}>
              <Link to="/book">
                <Button variant="outlined">Book</Button>
              </Link>
            </CardActions>
          </div>
          {/* </CardContent> */}
        </Card>
      </div>

      {/* WATER ACCESS CARD */}
      <div>
        <Card className="card" sx={{ ":hover": { boxShadow: 20 } }}>
          <img src={kayak} height="330em" />
          {/* <CardContent className="cardContent"> */}
          <div className="cardContent">
            <Typography variant="h5" className="homepage-cardtitle">
              Water Access
            </Typography>
            <Typography className="card-text">
              We are the only private campground in Tobermory with access to
              Lake Huron! We have kayaks, canoes, and SUPs to rent (or of course
              feel free to bring your own!). We also have a small beach, dock
              space, and a boat launch.
            </Typography>
            <CardActions sx={{ paddingLeft: "0" }}>
              <Link to="/rentals">
                <Button variant="outlined">Rental Info</Button>
              </Link>
            </CardActions>
            {/* </CardContent> */}
          </div>
        </Card>
      </div>

      {/* RULES CARD */}
      <div to="/rules">
        <Card className="card" sx={{ ":hover": { boxShadow: 20 } }}>
          <img src={rulesPic} height="330em" />
          <div className="cardContent">
            {/* <CardContent className="cardContent"> */}
            <Typography variant="h5" className="homepage-cardtitle">
              Rules
            </Typography>
            <Typography className="card-text">
              Please respect our forest and leave zero impact on your campsite.
              This includes not taking any wood from the forest or breaking off
              branches from trees. Please read our park rules to make sure we
              are a good fit for you!
            </Typography>
            <CardActions sx={{ paddingLeft: "0" }}>
              <Link to="/rules">
                <Button variant="outlined">Park Rules</Button>
              </Link>
            </CardActions>
          </div>
          {/* </CardContent> */}
        </Card>
      </div>

      {/* WINTER STORAGE CARD */}
      <div to="/winterstorage">
        <Card className="card" sx={{ ":hover": { boxShadow: 20 } }}>
          <img src={wintertrailer} height="330em" />
          <CardContent className="cardContent">
            <Typography variant="h5" className="homepage-cardtitle">
              Winter Trailer Storage
            </Typography>
            <Typography className="card-text">
              Store your trailer with us for the winter for $300.
            </Typography>
            <CardActions sx={{ paddingLeft: "0" }}>
              <Link to="/winterstorage">
                <Button variant="outlined">Learn More</Button>
              </Link>
            </CardActions>
          </CardContent>
        </Card>
      </div>

      {/* MAP CARD */}
      <div to="/map">
        <Card className="card" sx={{ ":hover": { boxShadow: 20 } }}>
          <img src={personwithmap} height="330em" />
          <CardContent className="cardContent">
            <Typography variant="h5" className="homepage-cardtitle">
              Park Map
            </Typography>
            <Typography className="card-text">
              View or print a map of the park. We also have printed maps
              available at the camp office. When you arrive you will be given
              one and shown the way to your site.
            </Typography>
            <CardActions sx={{ paddingLeft: "0" }}>
              <Link to="/map">
                <Button variant="outlined">Park Map</Button>
              </Link>
            </CardActions>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
